(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dg-recommended-accessories"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dg-recommended-accessories')) {
    customElements.define('dg-recommended-accessories', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.button = this.querySelector('[data-dg-accessory-add]');
        this.message = this.querySelector('[data-dg-accessory-message]');
        this.cartLink = this.querySelector('[data-dg-accessory-cart]');
        this.label = this.button.textContent;
        this.busy = false;
        this.options.forEach(input => { input.checked = false; });
        this.addEventListener('change', () => this.update(), { signal: this.controller.signal });
        this.querySelector('form').addEventListener('submit', event => this.add(event), { signal: this.controller.signal });
        this.update();
      }
      disconnectedCallback() { this.controller?.abort(); }
      get options() { return [...this.querySelectorAll('[data-dg-accessory-option]')]; }
      get selected() { return this.options.filter(input => input.checked && !input.disabled); }
      update() {
        const total = this.selected.reduce((sum, input) => sum + Number(input.dataset.price), 0);
        this.querySelector('[data-dg-accessory-total]').textContent = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency }).format(total / 100);
        this.button.disabled = this.busy || !this.selected.length;
      }
      async add(event) {
        event.preventDefault();
        if (this.busy || !this.selected.length) return;
        const selected = this.selected;
        this.busy = true;
        this.update();
        this.options.forEach(input => { input.dataset.wasDisabled = String(input.disabled); input.disabled = true; });
        this.button.setAttribute('aria-busy', 'true');
        this.button.textContent = this.dataset.loading;
        this.message.textContent = '';
        this.cartLink.hidden = true;
        const root = window.Shopify?.routes?.root || '/';
        let added = false;
        try {
          const sections = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: selected.map(input => ({ id: input.value, quantity: 1 })), sections: [...new Set(sections)].slice(0, 5), sections_url: window.location.pathname })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || this.dataset.error);
          added = true;
          selected.forEach(input => { input.checked = false; });
          this.message.textContent = this.dataset.success;
          this.cartLink.hidden = false;
          const cartResponse = await fetch(root + 'cart.js');
          if (!cartResponse.ok) throw new Error(this.dataset.syncError);
          const cart = await cartResponse.json();
          cart.sections = result.sections || {};
          this.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: result.items, cart, onSuccessDo: 'force_open_drawer' } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart, onSuccessDo: 'force_open_drawer' } }));
          if (Object.values(cart.sections).some(html => !html)) document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (error) {
          this.message.textContent = added ? this.dataset.syncError : this.dataset.error;
          this.cartLink.hidden = false;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } finally {
          this.busy = false;
          this.options.forEach(input => { input.disabled = input.dataset.wasDisabled === 'true'; });
          this.button.removeAttribute('aria-busy');
          this.button.textContent = this.label;
          this.update();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
